/** Link for "Report on these" from the Cattle list: its current filters, or the selected animals. */
export function cattleReportLink(filters: { q?: string; status?: string; class?: string; place?: string; group?: string; animals?: string[] }): string {
  const p = new URLSearchParams({ from: "cattle" });
  for (const [k, v] of Object.entries(filters)) {
    if (Array.isArray(v)) { if (v.length) p.set(k, v.join(",")); } else if (v) p.set(k, v);
  }
  return `/ranch/reports/new?${p.toString()}`;
}
